module.exports = __webpack_public_path__ + "media/images/humidity-orange-442575e640905f4c78558f364e388698.svg";